import script from "./pick-color.vue?vue&type=script&setup=true&lang=ts"
export * from "./pick-color.vue?vue&type=script&setup=true&lang=ts"

import "./pick-color.vue?vue&type=style&index=0&id=3e80744e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e80744e"]])

export default __exports__